import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DetailsHistorieStatus, VersionFeld } from '../../models/details-historie.model';
import { DetailsHistorieStatusComponent } from '../details-historie-card/details-historie-status/details-historie-status.component';

const LEERER_WERT = '—';

function istGesetzt(wert: string | number | null | undefined): boolean {
  return wert !== null && wert !== undefined && String(wert).trim() !== '';
}

@Component({
  selector: 'app-version-diff-list',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe, TranslatePipe, DetailsHistorieStatusComponent],
  templateUrl: './version-diff-list.component.html',
  styleUrl: './version-diff-list.component.scss',
})
export class VersionDiffListComponent {
  readonly vonVersion = input<string | number | null>(null);
  readonly zuVersion = input<string | number | null>(null);
  readonly autorName = input<string | null>(null);
  readonly geaendertAm = input<string | null>(null);
  readonly felder = input<VersionFeld[]>([]);
  readonly status = input<DetailsHistorieStatus>('bereit');
  readonly fehlerText = input<string | null>(null);
  readonly retry = output<void>();

  protected readonly zeitMuster = 'dd.MM.yyyy, HH:mm';
  protected readonly hatVorversion = computed(() => istGesetzt(this.vonVersion()));
  protected readonly hatZuVersion = computed(() => istGesetzt(this.zuVersion()));
  protected readonly autor = computed(() => this.autorName()?.trim() ?? '');
  protected readonly anzahlSchluessel = computed(() =>
    this.felder().length === 1
      ? 'common.detailsHistorie.versionen.aenderungenOne'
      : 'common.detailsHistorie.versionen.aenderungenOther',
  );

  protected wert(text: string | null): string {
    return text?.trim() ? text : LEERER_WERT;
  }
}
